import { useEffect, useRef } from 'react';
import { any, equals, pathOr } from 'ramda';
import { isNotNilOrEmpty } from '@@serverHelpers/index.mjs';
import {
  RESIDENCE_COUNTRY_FIELD,
  isForeignResidence,
  isFranceCountry
} from '@@viewHelpers/residenceCountry.js';

const INTERNATIONAL_CODE_FIELDS = [
  'customer.phones.0.internationalCode',
  'customer.phones.1.internationalCode'
];

const indicativeListOf = (country) =>
  isForeignResidence(country) ? 'international' : 'french';

/**
 * @param {*} form
 * @param {{ getMiddleBoolean?: function, dataStepKeys?: Array<string> }} options
 */
const useResidenceCountry = (
  form,
  { getMiddleBoolean, dataStepKeys = [] } = {}
) => {
  const country = form.watch(RESIDENCE_COUNTRY_FIELD);

  // get area code from country
  const previousCountry = useRef(country);
  const savedIndicatives = useRef({});

  useEffect(() => {
    if (equals(previousCountry.current, country)) {
      return;
    }

    const previousList = indicativeListOf(previousCountry.current);
    const nextList = indicativeListOf(country);

    previousCountry.current = country;

    if (equals(previousList, nextList)) {
      return;
    }

    savedIndicatives.current = {
      ...savedIndicatives.current,
      [previousList]: INTERNATIONAL_CODE_FIELDS.map((field) =>
        form.getValues(field)
      )
    };

    INTERNATIONAL_CODE_FIELDS.forEach((field, index) =>
      form.setValue(
        field,
        pathOr('', [nextList, index], savedIndicatives.current)
      )
    );
  }, [country]);

  const countryIsFrance = isFranceCountry(country);
  const countryIsSelected = isNotNilOrEmpty(country);

  const displayResidenceCountry = Boolean(
    getMiddleBoolean &&
      getMiddleBoolean('ADHERENT_PAYS_RESIDENCE_EST_NECESSAIRE') &&
      any((key) => getMiddleBoolean(key), dataStepKeys)
  );

  return {
    country,
    countryIsFrance,
    countryIsSelected,
    displayResidenceCountry,

    displayFrenchAddressFields:
      !displayResidenceCountry || (countryIsSelected && countryIsFrance),
    displayForeignAddressFields:
      displayResidenceCountry && countryIsSelected && !countryIsFrance,
    displayPhoneFields: !displayResidenceCountry || countryIsSelected,
    useFrenchPhoneRules: !isForeignResidence(country)
  };
};

export default useResidenceCountry;
